import React, { useMemo } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import {
  getProfileConfigHistoryDeviceList,
  getProfileConfigHistoryList
} from "@/apis/apiCollection";
import dayjs from "dayjs";
import DataTable from "@/components/DataTable";

export const InstallType = {
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2
};
const DeviceModal = ({ type, open, onClose, configHistoryId }) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    if (type === InstallType.SUCCESS)
      return t({ defaultMessage: "已安装设备" });
    if (type === InstallType.PENDING)
      return t({ defaultMessage: "待安装设备" });
    if (type === InstallType.FAILED)
      return t({ defaultMessage: "无法安装设备" });
  }, [type]);

  const columns = useMemo(() => {
    const columns = [
      {
        data: "groupName",
        title: t({ defaultMessage: "门店名称" }),
        orderable: false
      },
      {
        data: "name",
        title: t({ defaultMessage: "设备名称" }),
        orderable: false
      },
      {
        data: "serialNumber",
        title: t({ defaultMessage: "设备SN" }),
        orderable: false
      }
    ];
    if (type === InstallType.SUCCESS)
      columns.push({
        data: "installedAt",
        title: t({ defaultMessage: "安装时间" }),
        orderable: false,
        render: data => {
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        }
      });
    else if (type === InstallType.PENDING)
      columns.push({
        data: "effectedAt",
        title: t({ defaultMessage: "预计安装时间" }),
        orderable: false,
        render: data => {
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        }
      });
    else if (type === InstallType.FAILED)
      columns.push({
        data: "detail",
        title: t({ defaultMessage: "原因" }),
        orderable: false
      });
    return columns;
  }, [type]);

  const ajax = (data, callback) => {
    return getProfileConfigHistoryDeviceList({
      page: data.page,
      pageSize: data.pageSize,
      configHistoryId,
      deployStatus: type
    }).then(res => {
      callback({
        data: res.configHistoryDevices,
        draw: data.draw,
        recordsFiltered: res.total,
        recordsTotal: res.total
      });
    });
  };

  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      onConfirm={onClose}
      width={1200}
    >
      <DataTable
        ordering
        columns={columns}
        ajax={ajax}
        scrollable
        showCheckAll={false}
        autoLoad
      />
    </Modal>
  );
};

export default DeviceModal;
